/** Accessible name for a cart line photo. The button replaces the image alt, so the name keeps the action and the product. */
export function cartPhotoLabel(title1: string | null | undefined, title2: string | null | undefined): string {
    const name = [title1, title2]
        .map(part => (part ?? '').trim())
        .filter(part => part.length > 0)
        .join(' ');
    return name.length > 0 ? `Show product photo of ${name}` : 'Show product photo';
}
